import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  amount: Yup.number()
    .required("Amount is required")
    .min(0, "Amount must be a positive number")
    .typeError("Amount must be a number"),
  variableCost: Yup.string().required(
    "Please select an option regarding the variable cost."
  ),
  jobConfigDescription: Yup.string().required("Please enter job description."),
  overheadCostsToggle: Yup.string().required(
    "Please select an option regarding overhead cost"
  ),
  // overheadCosts: Yup.number().when("overheadCostsToggle", {
  //   is: "yes",
  //   then: (schema) =>
  //     schema
  //       .required("Overhead cost is required")
  //       .min(0, "Overhead cost must be a positive number")
  //       .typeError("Overhead cost must be a number"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  overheadCosts: Yup.number()
    .required("Overhead cost is required")
    .min(0, "Overhead cost must be a positive number")
    .typeError("Overhead cost must be a number"),
  ownersPay: Yup.number()
    .required("Owner cash is required")
    .min(0, "Owner cash must be a positive number")
    .typeError("Owner cash must be a number"),
  loans: Yup.number()
    .required("Vehicle loans are required")
    .min(0, "Vehicle loans must be a positive number")
    .typeError("Vehicle loans must be a number"),
  other: Yup.number()
    .required("Other loans are required")
    .min(0, "Other loans must be a positive number")
    .typeError("Other loans must be a number"),
  employees: Yup.string()
    .oneOf(["yes", "no"], "Please select if you have employees.")
    .required("Please select if you have employees."),
  highPaid: Yup.number().when("employees", {
    is: "yes",
    then: (schema) =>
      schema
        .required("High paid rate is required")
        .min(0, "High paid rate must be a positive number")
        .typeError("High paid rate must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
  monthlyHighPaid: Yup.number().when("employees", {
    is: "yes",
    then: (schema) =>
      schema
        .required("High paid employee count is required")
        .min(0, "High paid employee count must be a positive number")
        .typeError("High paid employee count must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
  midPaid: Yup.number().when("employees", {
    is: "yes",
    then: (schema) =>
      schema
        .required("Mid paid rate is required")
        .min(0, "Mid paid rate must be a positive number")
        .typeError("Mid paid rate must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
  monthlyMidPaid: Yup.number().when("employees", {
    is: "yes",
    then: (schema) =>
      schema
        .required("Mid paid employee count is required")
        .min(0, "Mid paid employee count must be a positive number")
        .typeError("Mid paid employee count must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
  lowPaid: Yup.number().when("employees", {
    is: "yes",
    then: (schema) =>
      schema
        .required("Low paid rate is required")
        .min(0, "Low paid rate must be a positive number")
        .typeError("Low paid rate must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
  monthlyLowPaid: Yup.number().when("employees", {
    is: "yes",
    then: (schema) =>
      schema
        .required("Low paid employee count is required")
        .min(0, "Low paid employee count must be a positive number")
        .typeError("Low paid employee count must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
  highPaidsecd: Yup.number().when("employees", {
    is: "no",
    then: (schema) =>
      schema
        .required("Hourly rate is required")
        .min(0, "Hourly rate must be a positive number")
        .typeError("Hourly rate must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export default validationSchema;

// overheadCosts: Yup.array()
//   .of(
//     Yup.string().required("Please select an option regarding overhead cost")
//   )
//   .required("Overhead cost selection is required")
//   .min(1),
// overheadCost: Yup.number().when("overheadCosts[0]", {
//   is: "yes",
//   then: (schema) =>
//     schema
//       .required("Overhead cost is required")
//       .min(0, "Overhead cost must be a positive number")
//       .typeError("Overhead cost must be a number"),
//   otherwise: (schema) => schema.notRequired(),
// }),
